<template>
  <div class="page-container">
    <div class="sub-header">
      <h2>قیمت خودرو</h2>
    </div>
    <div
      class="secondary-text-color border-color card"
      style="position: relative"
    >
      <div v-if="!loader">
        <h3 class="textCenter mar10b">
          <i class="fa fa-search"></i>
          جستجوی ماشین مورد نظر
        </h3>
        <p class="textCenter mar10b">پر کردن تمام فیلترهای جستجو اجباری نیست</p>
        <div class="filters">
          <div class="car-item-title">
            <div>
              <svg
                height="20px"
                viewBox="0 0 32 32"
                width="20px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g id="Chevron_Down_Circle">
                  <path
                    d="M16,0C7.164,0,0,7.163,0,16c0,8.836,7.164,16,16,16c8.837,0,16-7.164,16-16C32,7.163,24.837,0,16,0z M16,30   C8.28,30,2,23.72,2,16C2,8.28,8.28,2,16,2c7.72,0,14.031,6.28,14.031,14C30.031,23.72,23.72,30,16,30z"
                    fill="#121313"
                  />
                  <path
                    d="M22.3,12.393l-6.285,6.195l-6.285-6.196c-0.394-0.391-1.034-0.391-1.429,0   c-0.394,0.391-0.394,1.024,0,1.414l6.999,6.9c0.384,0.38,1.044,0.381,1.429,0l6.999-6.899c0.394-0.391,0.394-1.024,0-1.414   C23.334,12.003,22.695,12.003,22.3,12.393z"
                    fill="#121313"
                  />
                </g>
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
            </div>
            <select
              class="secondary-text-color"
              v-model="selectedBrand"
              @change="changeFiltered"
            >
              <option value="">براساس نوع خودرو</option>
              <option :value="item.Id" v-for="item in items" :key="item.Id">
                {{ item.Title }}
              </option>
            </select>
          </div>
          <!-- <div class="car-item-title">
            <div>
              <svg height="20px" viewBox="0 0 32 32" width="20px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Chevron_Down_Circle"><path d="M16,0C7.164,0,0,7.163,0,16c0,8.836,7.164,16,16,16c8.837,0,16-7.164,16-16C32,7.163,24.837,0,16,0z M16,30   C8.28,30,2,23.72,2,16C2,8.28,8.28,2,16,2c7.72,0,14.031,6.28,14.031,14C30.031,23.72,23.72,30,16,30z" fill="#121313"/><path d="M22.3,12.393l-6.285,6.195l-6.285-6.196c-0.394-0.391-1.034-0.391-1.429,0   c-0.394,0.391-0.394,1.024,0,1.414l6.999,6.9c0.384,0.38,1.044,0.381,1.429,0l6.999-6.899c0.394-0.391,0.394-1.024,0-1.414   C23.334,12.003,22.695,12.003,22.3,12.393z" fill="#121313"/></g><g/><g/><g/><g/><g/><g/></svg>
            </div>
            <select class="secondary-text-color" @change="getData()" v-model="categoryId">
              <option value="0">براساس کارخانه سازنده</option>
              <option value="1">سایپا</option>
              <option value="2">ایران خودرو</option>
              <option value="3">ایرانی</option>
              <option value="4">خارجی</option>
            </select>
          </div> -->
          <div v-if="categoryId == 0 && !selectedBrand">
            <h3 class="textCenter mar10b mar10t">
              <i style="color: #1030db;" class="far fa-file-alt"></i>
              لیست قیمت خودروها
            </h3>
          </div>
        </div>
        <div v-if="categoryId != 0 || selectedBrand">
          <h3 class="textCenter mar10b mar10t">
            <i style="color: #1030db;" class="far fa-file-alt"></i>
            لیست قیمت خودروهای جستجو شده
          </h3>
        </div>
        <carPriceItem
          :carItem="item"
          :filtered="filtered"
          v-for="item in filteredData"
          :key="item.Id"
        ></carPriceItem>
      </div>
    </div>
    <div class="error-message" v-if="!loader && errorMessage">
      {{ errorMessage }}
    </div>

    <div class="loader" v-if="loader">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../service";
import { mapActions } from "vuex";
import carPriceItem from "../../components/carService/CarPriceItem";

export default {
  name: "car-price-list",
  props: {},
  components: { carPriceItem },
  data() {
    return {
      errorMessage: null,
      loader: false,
      selectedBrand: "",
      categoryId: 0,
      items: [],
      filtered: false,
    };
  },
  mounted: function() {
    if (this.$route.query.theme == "dark") {
      this.setTheme("dark");
    }
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }
    // this.filtered = (this.categoryId!=0 || this.selectedBrand);
    this.getData();
  },
  computed: {
    filteredData: function() {
      let filteredData = [];
      // this.filtered = (this.categoryId!=0 || this.selectedBrand);
      if (this.selectedBrand) {
        this.items.forEach((element) => {
          if (element.Id == this.selectedBrand) {
            filteredData.push(element);
          }
        });

        return filteredData;
      } else {
        return this.items;
      }
    },
  },
  methods: {
    ...mapActions(["setTheme", "setToken"]),
    changeFiltered: function() {
      this.filtered = this.categoryId != 0 || this.selectedBrand.length !== 0;
    },
    getData: function() {
      this.loading = true;
      this.changeFiltered();
      api
        .getCarPriceList({ categoryId: this.categoryId })
        .then((response) => {
          if (response.data && response.data.Status === 200) {
            let result = [];

            for (let i = 0; i < response.data.Data.length; i++) {
              const element = response.data.Data[i];
              let found = false;
              result.forEach((el) => {
                if (el.Id === element.BrandId) {
                  found = true;

                  let lowest = 0;
                  let highest = 0;
                  let tmp = [];
                  let carName = element.CarName;
                  for (let j = 0; j < element.Prices.length; j++) {
                    var a = element.Prices[j].BazarPrice;
                    var b = element.Prices[j].AgentPrice;
                    if (a) tmp.push(a);
                    if (b) tmp.push(b);
                  }
                  if (tmp && tmp.length > 0) {
                    tmp.sort();
                    highest = tmp[0];
                    lowest = tmp[tmp.length - 1];
                  }

                  el.Cars.push({
                    Id: element.CarId,
                    Title: carName,
                    MinPrice: lowest,
                    CarImageUrl: element.CarImageUrl,
                    MaxPrice: highest,
                    Percent: 0,
                  });
                }
              });

              if (!found) {
                let lowest = 0;
                let highest = 0;
                let tmp = [];
                let carName = element.CarName;
                for (let j = 0; j < element.Prices.length; j++) {
                  var a = element.Prices[j].BazarPrice;
                  var b = element.Prices[j].AgentPrice;
                  if (a) tmp.push(a);
                  if (b) tmp.push(b);
                }
                if (tmp && tmp.length > 0) {
                  tmp.sort();
                  highest = tmp[0];
                  lowest = tmp[tmp.length - 1];
                }
                const item = {
                  Id: element.BrandId,
                  Title: element.BrandName,
                  BrandImageUrl: element.BrandImageUrl,
                  Cars: [
                    {
                      Id: element.CarId,
                      Title: carName,
                      CarImageUrl: element.CarImageUrl,
                      MinPrice: lowest,
                      MaxPrice: highest,
                      Percent: 0,
                    },
                  ],
                };

                result.push(item);
              }
            }

            this.items = result;
          } else {
            if (
              response.data &&
              response.data.Messages &&
              response.data.Messages.length > 0
            ) {
              this.errorMessage = response.data.Messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage =
            "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
body {
  background: #fff;
}
.img-header {
  width: 65px;
  border: 1px solid;
  padding: 4px;
  border-radius: 50%;
  height: 65px;
  z-index: 100;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-container {
  padding: 0;
}

.page-container p {
  color: #1030db;
}

.card {
  margin: 10px 10px 0 10px;
  border-radius: 5px;
  padding: 15px 7px;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 1px 3px 1px #ccc;
}

.filters {
  display: flex;
  flex-direction: column;
}

.filters > div {
  flex: 1;
  padding: 5px;
}

.filters select {
  width: 100%;
  background-color: transparent;
  border: none;
  padding: 8px;
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

.filters h3 {
  color: #666;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filters h3 i {
  color: #1030db;
  font-size: 1rem;
  padding: 0 5px;
}

.car-item-title {
  position: relative;
  display: flex;
  background-color: #f9f9f9;
  border: solid 1px #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 2px 1px 0 #ccc;
  padding: 0 !important;
  margin: 0 6px 10px;
}

.car-item-title div {
  position: absolute;
  left: 0px;
  background: #fff;
  height: 100%;
  padding: 0 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.car-item-title svg {
  margin-top: 8px;
}
</style>

<!--
<template>
    <div class="carsPriceBg">
      <div class="carsPriceBox">
        <img src="../../assets/img/pic_car_price.jpg">
        <h2 class="textCenter">این بخش به زودی فعال میشود!</h2>
      </div>
    </div>
</template>

<style scoped>
  h2{
    margin: 5px 0 15px 0;
    color: #0a48c2;
    font-size: 18px;
  }
  .carsPriceBg{
    background-image: url(../../assets/img/bg_car_price.jpg);
    height: 100%;
    background-position: center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .carsPriceBg img{
    width: 100%;
    border-radius: 20px 20px 0 0;
  }
  .carsPriceBox{
    background: #fff;
    border-radius: 20px;
    margin: 0 10px;
    box-shadow: 0 0 10px #00000070;
  }
  .carsPriceBg button{
    margin-top: 20px;
    background-color: #002664;
  }
</style>
-->
